"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllPermissions = exports.SystemPermissions = exports.ReportsPermissions = exports.PayrollPermissions = exports.ServiceTypesPermissions = exports.PayTypesPermissions = exports.CustomerRateProfilePermissions = exports.DriverRateProfilePermissions = exports.InvoicePermissions = exports.TruckPermissions = exports.CustomerPermissions = exports.TDMPermissions = exports.DriverPermissions = exports.UserManagementPermissions = void 0;
exports.UserManagementPermissions = [
    'USER_MANAGE_INVITE',
    'USER_MANAGE_UPDATE_EMAIL',
    // ! CAUTION - giving a user this permission allows them to update the roles of any and all users
    'USER_MANAGE_UPDATE',
    'USER_MANAGE_UPDATE_PASSWORD',
    'USER_MANAGE_USER_READ',
    'USER_MANAGE_USER_READ_MANY',
    'USER_MANAGE_DELETE',
    'USER_MANAGE_VIEW_AUDITS',
];
exports.DriverPermissions = [
    'DRIVER_CREATE',
    'DRIVER_READ',
    'DRIVER_UPDATE',
    'DRIVER_READ_MANY',
    'DRIVER_DELETE',
];
exports.TDMPermissions = [
    'TDM_CREATE',
    'TDM_READ',
    'TDM_UPDATE',
    'TDM_READ_MANY',
    'TDM_DELETE',
];
exports.CustomerPermissions = [
    'CUSTOMER_LIST_ORGS',
    'CUSTOMER_LIST_MANAGERS',
    'CUSTOMER_CREATE',
    'CUSTOMER_READ',
    'CUSTOMER_UPDATE',
    'CUSTOMER_READ_MANY',
    'CUSTOMER_DELETE',
];
exports.TruckPermissions = [
    'TRUCK_CREATE',
    'TRUCK_SEARCH',
    'TRUCK_READ',
    'TRUCK_UPDATE',
    'TRUCK_READ_MANY',
];
exports.InvoicePermissions = [
    'INVOICE_CREATE',
    'INVOICE_READ',
    'INVOICE_UPDATE',
    'INVOICE_READ_MANY',
];
exports.DriverRateProfilePermissions = [
    'DRP_CREATE',
    'DRP_READ',
    'DRP_UPDATE',
    'DRP_READ_MANY',
    'DRP_DELETE',
];
exports.CustomerRateProfilePermissions = [
    'CRP_CREATE',
    'CRP_READ',
    'CRP_UPDATE',
    'CRP_READ_MANY',
    'CRP_DELETE',
];
exports.PayTypesPermissions = ['PAY_TYPES_READ', 'PAY_TYPES_READ_MANY'];
exports.ServiceTypesPermissions = ['SERVICE_TYPES_READ', 'SERVICE_TYPES_READ_MANY'];
exports.PayrollPermissions = [
    'PAYROLL_CREATE',
    'PAYROLL_READ',
    'PAYROLL_DELETE',
    'PAYROLL_DATES',
    'PAYROLL_ADD_TRUCKS',
    'PAYROLL_GENERATE',
    'PAYROLL_FINALIZE',
];
exports.ReportsPermissions = ['SALES_GENERATE', 'DELIVERY_CHARGE_GENERATE'];
exports.SystemPermissions = ['SYSTEM_SETTINGS_UPDATE'];
exports.AllPermissions = [
    'NONE',
    ...exports.UserManagementPermissions,
    ...exports.DriverPermissions,
    ...exports.TDMPermissions,
    ...exports.CustomerPermissions,
    ...exports.TruckPermissions,
    ...exports.InvoicePermissions,
    ...exports.DriverRateProfilePermissions,
    ...exports.CustomerRateProfilePermissions,
    ...exports.PayTypesPermissions,
    ...exports.ServiceTypesPermissions,
    ...exports.PayrollPermissions,
    ...exports.ReportsPermissions,
    ...exports.SystemPermissions,
];
//# sourceMappingURL=permissions.type.js.map